import styled from "styled-components";

export const StyledFloatOverlayHookWrapper = styled.div<{ bottom?: number }>`
    position: absolute;
    bottom: ${({ bottom }) => bottom || 0}px;
    left: 0;
    width: 100%;
    z-index: 999;
`;
